import ProductCard from "components/card/product/ProductCard";
import ProgressbarSwiper from "components/swiper/ProgressBarSwiper";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import { Swiper, SwiperSlide } from "swiper/react";

import Center from "layouts/wrapper/Center";
import P from "components/P";
import Dummy from "components/Dummy";
import WeeklyBestSeller from "components/swiper/WeeklyBestSeller";
import CardList from "layouts/wrapper/CardList";
import QuillViewer from "components/inputs/richEditor/QuillViewer";
import { useNavigate } from "react-router-dom";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NewProductSwiper from "components/swiper/NewProductSwiper";
import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import { storeRequester } from "App";

import { BrowserDetectContext } from "providers/BrowserEventProvider";
import NewProductProgressBarSwiper from "components/swiper/NewProductProgressBarSwiper";
import { decode } from "shared/utils/Utils";
import EventSwiper from "components/swiper/EventSwiper";

function MobileHome({ banner, restockProducts, medusaProducts, img }) {
  const { isMobile } = useContext(BrowserDetectContext);
  
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [newProducts, setNewProducts] = useState();

  useEffect(() => {
    storeRequester.getDiscounts(
      {
        code: "NEW",
        type: "main",
      },
      ({ data }) =>
        setNewProducts(
          [
            ...data.variants.reduce((products, variant) => {
              const product = products.find(
                (product) => product.id === variant.product_id
              );
              if (product) {
                if (!product?.variants?.find((v) => v.id === variant.id)) {
                  product.variants = [...(product.variants || []), variant];
                }
              } else {
                return [
                  ...products,
                  { ...variant.product, variants: [variant] },
                ];
              }
              return products;
            }, data.products || []),
          ] || []
        )
    );
  }, []);
  const bannerDetailClick = (row) => {
    if (row.board.name === "banner") {
      if (row.metadata.link?.length > 0) {
        navigate(row?.metadata.link);
      } else {
        navigate("/article/notice/detail", { state: { data: row } });
      }
    } else {
      navigate("/article/notice/detail", { state: { data: row } });
    }
  };

  return (
    <Container maxWidth={"100%"}>
      <VerticalFlex gap={5}>
        {banner && banner.length > 0 && (
          <FlexChild>
            <Dummy height={"40px"} />
            {/* <div
              style={{
                // backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                width: "95%",
                // height: '260px', // Adjust height as needed
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                borderRadius: "10px",
                overflow: "hidden",
              }}
            >
              <Swiper>
                {banner &&
                  banner.map((data, index) => (
                    <SwiperSlide>
                      <div
                        onClick={(e) => {
                          e.preventDefault(); // 기본 동작 방지
                          bannerDetailClick(data);
                        }}
                      >
                        <QuillViewer
                          value={
                            data && data.content?.startsWith("PHA")
                              ? decode(data.content)
                              : data.content
                          }
                        />
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
              <div
                onClick={() => navigate("/article/notice")}
                style={{
                  width: "95%",
                  zIndex: 9,
                  position: "absolute",
                  display: "flex",
                  justifyContent: "space-between",
                  cursor: "pointer",
                  backgroundColor: "rgba(77, 79, 86, 0.7)",
                  borderBottomLeftRadius: "10px",
                  borderBottomRightRadius: "10px",
                  padding: "0.5rem",
                }}
              >
                {" "}
                <P color={"white"} size={18}>
                  공지사항 더 보기
                </P>
                <FontAwesomeIcon
                  icon={faAngleRight}
                  color={"white"}
                  style={{ transform: "translateY(5px)" }}
                />
              </div>
            </div> */}
          </FlexChild>
        )}
        <FlexChild>
          <Dummy height={"20px"} />
          <CardList
            title={"전체상품"}
            data={medusaProducts}
            template={"addWish"}
          />
        </FlexChild>
      </VerticalFlex>
    </Container>
  );
}
export default MobileHome;
